"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _reactVirtualized = require("react-virtualized");
var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));
var _Input = _interopRequireDefault(require("../input/Input"));
var _heading = require("../heading");
var _stepper = require("../stepper");
var _misc = require("../misc");
var _helpers = require("./helpers");
var _Timepicker = _interopRequireDefault(require("./Timepicker.style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var TimePicker = /*#__PURE__*/function (_PureComponent) {
  _inherits(TimePicker, _PureComponent);
  var _super = _createSuper(TimePicker);
  function TimePicker(props) {
    var _this;
    _classCallCheck(this, TimePicker);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onChange", function (index, time) {
      _this.setState({
        isOpen: false,
        activeIndex: index
      });
      _this.props.onChange(time);
    });
    _defineProperty(_assertThisInitialized(_this), "onMeridiemChange", function (tabIndex) {
      _this.setState({
        meridiemType: _helpers.MERIDIEM_TYPE[tabIndex]
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleFocus", function () {
      var activeIndex = _this.state.activeIndex;
      _this.setState(function () {
        return {
          isOpen: true
        };
      }, function () {
        _this.listRef.current.scrollToRow(activeIndex || 0);
      });
      _this.props.onFocus();
    });
    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function () {
      _this.setState({
        isOpen: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderListItems", function (_ref) {
      var index = _ref.index,
        style = _ref.style,
        hours = _ref.hours,
        activeIndex = _ref.activeIndex;
      var hour = R.prop(index, hours);
      return /*#__PURE__*/_react["default"].createElement("button", {
        key: hour,
        className: index === activeIndex ? 'active' : '',
        onClick: function onClick() {
          return _this.onChange(index, hour);
        },
        style: style
      }, hour);
    });
    var isMeridiem = props.isMeridiem;
    _this.state = {
      isOpen: false,
      activeIndex: null,
      meridiemType: isMeridiem ? _helpers.MERIDIEM_TYPE[0] : '',
      hours: (0, _helpers.setHours)(isMeridiem)
    };
    _this.listRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  _createClass(TimePicker, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        id = _this$props.id,
        value = _this$props.value,
        placeholder = _this$props.placeholder,
        isMeridiem = _this$props.isMeridiem,
        position = _this$props.position,
        withIcon = _this$props.withIcon,
        errors = _this$props.errors,
        disabled = _this$props.disabled;
      var _this$state = this.state,
        isOpen = _this$state.isOpen,
        activeIndex = _this$state.activeIndex,
        hours = _this$state.hours,
        meridiemType = _this$state.meridiemType;
      var time = value instanceof Date ? (0, _helpers.getTime)(value, isMeridiem) : (0, _helpers.checkTimeFormat)({
        value: value,
        hours: hours,
        isMeridiem: isMeridiem
      });
      return /*#__PURE__*/_react["default"].createElement(_Timepicker["default"], {
        className: "timepicker-wrapper",
        position: position
      }, /*#__PURE__*/_react["default"].createElement(_Input["default"], {
        id: "".concat(id, "Input"),
        type: "text",
        disabled: disabled,
        placeholder: placeholder,
        icon: withIcon ? 'ion-android-time' : '',
        errors: errors,
        onFocus: this.handleFocus,
        value: time,
        readOnly: true
      }), isOpen && /*#__PURE__*/_react["default"].createElement(_misc.StyledDropdown, {
        className: "timepicker-dropdown"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "header"
      }, /*#__PURE__*/_react["default"].createElement(_heading.H3, null, _helpers.TIME_LABEL), isMeridiem && /*#__PURE__*/_react["default"].createElement(_stepper.Tabs, {
        view: "pill",
        defaultActiveTabIndex: R.indexOf(meridiemType, _helpers.MERIDIEM_TYPE),
        onTabChange: this.onMeridiemChange
      }, /*#__PURE__*/_react["default"].createElement(_stepper.Tab, {
        allowNavigation: true,
        label: _helpers.MERIDIEM_TYPE[0]
      }), /*#__PURE__*/_react["default"].createElement(_stepper.Tab, {
        allowNavigation: true,
        label: _helpers.MERIDIEM_TYPE[1]
      }))), /*#__PURE__*/_react["default"].createElement(_reactVirtualized.AutoSizer, {
        disableHeight: true
      }, function (_ref2) {
        var width = _ref2.width;
        return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.List, {
          ref: _this2.listRef,
          rowCount: R.length(hours),
          width: width,
          height: _helpers.LIST_HEIGHT,
          rowHeight: _helpers.ROW_HEIGHT,
          rowRenderer: function rowRenderer(_ref3) {
            var index = _ref3.index,
              style = _ref3.style;
            return _this2.renderListItems({
              index: index,
              style: style,
              hours: hours,
              activeIndex: activeIndex
            });
          },
          overscanRowCount: 3
        });
      }), /*#__PURE__*/_react["default"].createElement("div", null)));
    }
  }]);
  return TimePicker;
}(_react.PureComponent);
TimePicker.defaultProps = {
  value: '',
  placeholder: 'hh:mm',
  position: 'bottom',
  disabled: false,
  isMeridiem: false,
  withIcon: false,
  errors: undefined,
  onFocus: function onFocus() {}
};
TimePicker.propTypes = {
  /** Html id */
  id: _propTypes["default"].string.isRequired,
  /** Value can be in instance of Date which will extract the time or '00:00' || '12:00 AA' string format */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(Date)]),
  /** The short hint displayed in the input before the user enters a value. */
  placeholder: _propTypes["default"].string,
  /** The position where to render the calendar (relative to the input) */
  position: _propTypes["default"].oneOf(['top', 'left', 'bottom', 'right']),
  /** Html id */
  disabled: _propTypes["default"].bool,
  /** The time value */
  onChange: _propTypes["default"].func.isRequired,
  /** A list of erros associated to the input */
  errors: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  onFocus: _propTypes["default"].func,
  isMeridiem: _propTypes["default"].bool,
  withIcon: _propTypes["default"].bool
};
TimePicker.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }, {
      "name": "time",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onMeridiemChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "tabIndex",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleFocus",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleClickOutside",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "renderListItems",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "{ index, style, hours, activeIndex }",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "TimePicker",
  "props": {
    "value": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Value can be in instance of Date which will extract the time or '00:00' || '12:00 AA' string format",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "instanceOf",
          "value": "Date"
        }]
      },
      "required": false
    },
    "placeholder": {
      "defaultValue": {
        "value": "'hh:mm'",
        "computed": false
      },
      "description": "The short hint displayed in the input before the user enters a value.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "position": {
      "defaultValue": {
        "value": "'bottom'",
        "computed": false
      },
      "description": "The position where to render the calendar (relative to the input)",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'top'",
          "computed": false
        }, {
          "value": "'left'",
          "computed": false
        }, {
          "value": "'bottom'",
          "computed": false
        }, {
          "value": "'right'",
          "computed": false
        }]
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Html id",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "isMeridiem": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "withIcon": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "errors": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "A list of erros associated to the input",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "string"
          }
        }]
      },
      "required": false
    },
    "onFocus": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "id": {
      "description": "Html id",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "onChange": {
      "description": "The time value",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};
var _default = (0, _reactClickOutside["default"])(TimePicker);
exports["default"] = _default;